<template>
  <div
    id="vueApp"
    class="relative h-full"
  >
    <vue-announcer v-if="browser !== 'IE'"/>

    <Transition :name="transition">
      <router-view />
    </Transition>

    <vue-progress-bar />

    <Cookies
      v-if="!loading"
      href="https://www.uos.ac.uk/content/university-suffolk-cookie-information"
    />

    <Transition name="fade">
      <Loading
        v-if="loading"
      />
    </Transition>

    <IePrompt />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Loading from '@/components/utility/Loading.vue'
import IePrompt from '@/components/utility/IePrompt.vue'
import Cookies from '@/components/utility/Cookies.vue'
// Import data from '@/data.json'

export default {
  name: 'App',

  components: {
    Loading,
    IePrompt,
    Cookies
  },

  data: () => ({
    transition: ''
  }),

  computed: {
    ...mapState([ 'touch', 'browser', 'mobile', 'loading', 'environment', 'isMedia' ]),
    ...mapGetters([ 'post', 'posts', 'categories' ]),

    environment() {
      return process.env.VUE_APP_ENV
    },
    isMobile() {
      return !!(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md')
    },
    title() {
      return this.isMedia ? this.posts.find(({ slug }) => slug === this.$route.params.media_id).title : this.post.title
    }
  },

  watch: {
    $route: {
      immediate: false,
      handler(to, from) {
        document.title = `${this.htmlDecode(this.title)} | Virtual tour | University of Suffolk`
        this.$announcer.set(this.title)

        if (from.name) {
          this.transition = to.name === 'category' ? 'slide-view-right' : 'slide-view-left'
        }
      }
    },
    $mq: {
      immediate: true,
      handler() {
        const isMobile = this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg'
        this.$store.commit('isMobile', isMobile)
      }
    }
  },

  created() {
    this.$store.commit('browser', this.$browser.meta.name)
    this.$store.commit('environment', this.environment)

    // This.$store.commit('populate', data)

    this.$Progress.start()

    this.$router.beforeEach((to, from, next) => {
      this.$Progress.start()
      next()
    })

    this.$router.afterEach((to, from) => {
      this.$Progress.finish()
    })
  },

  mounted() {
    this.$Progress.finish()
    window.addEventListener('touchstart', this.isTouch)

    // GTM
    document.addEventListener('keydown', () => {
      window.dataLayer.push({
        event: 'keyboardEvent',
        keyboardEvent: {
          key: event.key,
          path: this.$route.path
        }
      })
    })
  },

  methods: {
    isTouch() {
      this.$store.commit('isTouch')
      document.body.setAttribute('id', 'touch')
      window.removeEventListener('touchstart', this.isTouch)
    }
  }
}
</script>
